import { render, staticRenderFns } from "./mina.vue?vue&type=template&id=324d66b8&scoped=true&"
import script from "./mina.vue?vue&type=script&lang=js&"
export * from "./mina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324d66b8",
  null
  
)

export default component.exports